import React from 'react';
import { Toaster } from 'react-hot-toast';
import HeroSection from '../components/HeroSection';
import WhyUs from '../components/WhyUs';
import BstiSection from '../components/BstiSection';
import ReviewSection from '../components/ReviewSection';
import VideoReview from '../components/VideoReview';
import UrgencyBanner from '../components/UrgencyBanner';
import OrderSection from '../components/OrderSection';
import Footer from '../components/Footer';
import TopBar from '../components/TopBar';
import AdPosterSection from '../components/AdPosterSection';

const HomePage = () => {
  return (
    <div className="HomePage font-sans bg-gray-50 text-gray-900">
      <Toaster position="top-center" />
      <TopBar/>
      <HeroSection />
      <WhyUs />
      <BstiSection />
      <ReviewSection />
      <AdPosterSection />
      <VideoReview />
      <UrgencyBanner />
      <OrderSection />
      <Footer />
    </div>
  );
};

export default HomePage;
